import Vue from 'vue'
import AudioRecorder from 'vue-audio-recorder'
Vue.use(AudioRecorder)
